import { useCallback, useRef, useState, useEffect } from 'react';
import {
    Button,
    Input,
    Radio,
    Space,
    Select,
    Divider,
    Tooltip,
    notification,
    Cascader,
    Spin,
    Modal,
} from 'antd';
import { QuestionCircleOutlined, LoadingOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import XForm from 'components/XForm';
import { cityOptions } from 'constant/cityOptions';
import { getIdCardInfo, throttle } from 'utils';
import { applyTypes } from 'enumeration/applyTypes';
import { priorityTypes } from 'enumeration/priorityTypes';
import { educations } from 'enumeration/educations';
import { identityType } from 'enumeration/identityType';
import { maritalStatuTypes } from 'enumeration/maritalStatuTypes';
import { nursingAreas } from 'enumeration/nursingAreas';
import { userApplyApi, getApplyDetailsApi, putApplyModificationApi } from 'api/waitApplication';
import AliyunOSSUpload from 'components/AliyunOSSUpload';
import './style.less';
const { Option } = Select;
const { confirm } = Modal;
const ApplyInfo = props => {
    const { applyId } = props;
    const history = useHistory();
    const { id = applyId } = useParams();
    const { pathname } = useLocation();
    const xFormRef = useRef(null);
    const [fillIn, setFillIn] = useState(pathname.includes('fillInBaseInfo'));
    const [applyEdit, setApplyEdit] = useState(pathname.includes('applyEdit'));
    const [applyType, setApplyType] = useState('');
    const [age, setAge] = useState(0);
    const [assessmentTotal, setAssessmentTotal] = useState(0); // 评估总分
    const [infoLoading, setInfoLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [idNoImg, setIdNoImage] = useState('');
    const [hukoMain, setHokoMain] = useState('');
    const [hukoBenRen, setHokoBenren] = useState('');
    const [specialImg, setSpecialImg] = useState('');

    // 评估结果
    const assessmentRes = JSON.parse(sessionStorage.getItem('assessmentRes') || '{}');

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        // setIdNoImg([]);
        // setHokouMain([]);
        return () => window.removeEventListener('resize', handleResize);
    });

    const handleResize = throttle(() => {
        setWindowWidth(window.innerWidth);
    }, 300);

    // 设置详情
    const setInfoByDetail = useCallback(data => {
        const {
            idNo,
            guardianProvince = '',
            guardianCity = '',
            guardianArea = '',
            applyType,
            identityType,
            area,
            ...otherInfo
        } = data;
        const guardianAreas = [guardianProvince + '', guardianCity + '', guardianArea + ''].filter(
            item => item,
        );
        // area 转成字符串
        const areaStr = area.toString();
        const idProvince = areaStr.substring(0, 2) + '0000';
        const idCity = areaStr.substring(0, 4) + '00';
        const areas = [idProvince, idCity, areaStr];
        const idInfo = getIdCardInfo(idNo);
        const { gender, age, birthday } = idInfo;
        setAge(age);
        setApplyType(applyType);

        xFormRef.current.form?.setFieldsValue({
            ...otherInfo,
            idNo,
            gender,
            age,
            applyType,
            birthday,
            cardNo: idNo,
            guardianAreas,
            areas,
            identityType,
        });
    }, []);

    // 获取详情并设置form values
    useEffect(() => {
        const fillIn = pathname.includes('fillInBaseInfo');
        if (fillIn) return;
        setInfoLoading(true);
        getApplyDetailsApi({ id }).then(res => {
            if (res.success) {
                setInfoLoading(false);
                setInfoByDetail(res);
            }
        });
    }, [pathname, id, setInfoByDetail]);

    useEffect(() => {
        const fillIn = pathname.includes('fillInBaseInfo');
        setFillIn(fillIn);
        const applyEdit = pathname.includes('applyEdit');
        setApplyEdit(applyEdit);
    }, [pathname]);

    // 设置总分
    useEffect(() => {
        const resKeys = Object.keys(assessmentRes);
        let totalScore = 0;
        resKeys.forEach(key => {
            totalScore = totalScore + assessmentRes[key].totalScore;
        });
        setAssessmentTotal(totalScore);
    }, [assessmentRes]);

    // 未完成评估，不可填写申请
    // useEffect(() => {
    //     const resKeys = Object.keys(assessmentRes);
    //     if (resKeys.length < 4 && fillIn) {
    //         history.push('/userApply/assessment');
    //     }
    // }, [assessmentRes, history, fillIn]);

    // 提交
    const onFinish = values => {
        if (fillIn) {
            submitUserApply(values);
        }
        if (applyEdit) {
            submitApplyEdit(values);
        }
    };

    // 提交申请
    const submitUserApply = values => {
        const InfoKey = `notice_${new Date().getTime().toString()}`;
        const { guardianAreas = [], areas = [], priorityType } = values;
        console.log(values);
        if (idNoImg === undefined || idNoImg === null || idNoImg.length === 0) {
            notification.error({
                message: '身份证图片不能为空',
            });
            return;
        }
        if (hukoMain === undefined || hukoMain === null || hukoMain.length === 0) {
            notification.error({
                message: '户口本图片不能为空',
            });
            return;
        }
        if (hukoBenRen === undefined || hukoBenRen === null || hukoBenRen.length === 0) {
            notification.error({
                message: '户口本图片不能为空',
            });
            return;
        }
        setSubmitLoading(true);
        notification.info({
            duration: null,
            description: '提交申请中...',
            icon: <LoadingOutlined />,
            key: InfoKey,
        });
        const [guardianProvince, guardianCity, guardianArea] = guardianAreas;
        const [idProvince, idCity, area] = areas;
        const params = {
            ...values,
            guardianProvince,
            guardianCity,
            guardianArea,
            idProvince,
            idCity,
            area,
            priorityType: priorityType || 'ZERO',
            idNoImg: idNoImg[0].name,
            hukoMain: hukoMain[0].name,
            hukoBenRen: hukoBenRen[0].name,
        };

        if (specialImg.length > 0) {
            // params 追加元素
            params.specialImg = specialImg[0].name;
        }
        userApplyApi(params).then(res => {
            if (res.success) {
                applySuccess('add');
            }
            notification.close(InfoKey);
            setSubmitLoading(false);
        });
    };

    // 提交/修改申请成功回调
    const applySuccess = type => {
        confirm({
            title: `${type === 'edit' ? '申请变更' : '提交申请'}成功`,
            icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
            content: '是否跳转进度查询？',
            onOk() {
                history.push('/applySelfProgress');
            },
            onCancel() {
                if (type === 'add') {
                    xFormRef.current.form?.resetFields();
                }
            },
        });
    };

    // 申请变更
    const submitApplyEdit = values => {
        setSubmitLoading(true);
        const InfoKey = `notice_${new Date().getTime().toString()}`;
        notification.info({
            duration: null,
            description: '申请变更中...',
            icon: <LoadingOutlined />,
            key: InfoKey,
        });
        console.log(values);
        const { nursingArea, idNoImg, hukoBenRen, hukoMain, specialImg } = values;
        const params = {
            nursingArea,
            idNoImg: idNoImg[0].name,
            hukoMain: hukoMain[0].name,
            hukoBenRen: hukoBenRen[0].name,
            id: id,
        };
        if (specialImg !== undefined && specialImg !== null && specialImg.length > 0) {
            // params 追加元素
            params.specialImg = specialImg[0].name;
        }
        putApplyModificationApi(params).then(res => {
            if (res.success) {
                applySuccess('edit');
            }
            notification.close(InfoKey);
            setSubmitLoading(false);
        });
    };

    // 监听申请通道改变
    const applyTypeChange = e => {
        setApplyType(e.target.value);
    };

    // 申请人身份证校验
    const idNoValidator = (_, value) => {
        if (value) {
            const idInfo = getIdCardInfo(value);
            const { gender, age, birthday, success } = idInfo;

            if (success) {
                setAge(age);
                const idArea = value.substring(0, 6);
                const idProvince = value.substring(0, 2) + '0000';
                const idCity = value.substring(0, 4) + '00';
                xFormRef.current.form?.setFieldsValue({
                    gender,
                    age,
                    birthday,
                    cardNo: value,
                    idAddress: [idProvince, idCity, idArea],
                });
                if (age < 60) {
                    return Promise.reject(new Error('申请人年龄为必须60周岁以上'));
                } else {
                    return Promise.resolve();
                }
            } else {
                return Promise.reject(new Error('请输入正确的身份证号'));
            }
        } else {
            return Promise.reject(new Error('请输入身份证号'));
        }
    };

    // 建议护理区
    const defaultNursingAreas = useCallback(() => {
        let value = '';
        switch (true) {
            case assessmentTotal > 90:
                value = 'TAKE_CARE_SELF';
                break;
            case assessmentTotal > 80 && assessmentTotal <= 90:
                value = 'SEMI_CARE';
                break;
            default:
                if (age > 70) {
                    value = 'FULL_CARE';
                } else {
                    value = 'SEMI_CARE';
                }
                break;
        }
        const text = (nursingAreas.find(nursing => nursing.value === value) || {}).text;
        return {
            text,
            value,
        };
    }, [age, assessmentTotal]);

    const changeIdNoImg = info => {
        console.log(info);
        setIdNoImage(info);
    };

    const changeHokoMain = info => {
        setHokoMain(info);
    };

    const changeHokoBenRen = info => {
        setHokoBenren(info);
    };
    const changeSpecialImg = info => {
        setSpecialImg(info);
    };

    // 申请通道补充item
    const applyTypeTipItem = useCallback(() => {
        let applyTypeTipItem = null;
        switch (applyType) {
            case 'ORDINARY':
                applyTypeTipItem = {
                    item: (
                        <div style={{ paddingLeft: 120 }}>
                            <div>（一）申请条件</div>
                            <div style={{ paddingLeft: 20 }}>
                                <div>1、年满60周岁及以上老人。</div>
                                <div>
                                    2、无传染病、精神类疾病及暴力倾向，无其它不适合集体生活的疾病和生活习性等。
                                </div>
                                <div>
                                    3、2名有经济能力的担保人（担保人可为公民个人或单位法人，个人担保人应具有本市（含六区六县）户籍，有完全民事行为能力及相应的经济能力，至少1人年龄不满60周岁）。
                                </div>
                            </div>
                        </div>
                    ),
                };
                break;
            case 'PRIORITY':
                applyTypeTipItem = {
                    formItemApis: {
                        label: '优先保障对象',
                        tooltip: '以下类型老年人为优先保障对象',
                        name: 'priorityType',
                        rules: [{ required: true }],
                    },
                    item: (
                        <Radio.Group disabled={!fillIn}>
                            <Space direction="vertical">
                                {priorityTypes.map(({ value, text }) => {
                                    return (
                                        <Radio key={value} value={value}>
                                            {text}
                                        </Radio>
                                    );
                                })}
                            </Space>
                        </Radio.Group>
                    ),
                };
                break;
            default:
                applyTypeTipItem = {
                    item: (
                        <div style={{ paddingLeft: 120 }}>
                            特困轮候申请条件：城市特困人员，年龄为60周岁以上人员。
                        </div>
                    ),
                };
                break;
        }
        return applyTypeTipItem;
    }, [fillIn, applyType]);

    const formItems = () => {
        let IDItemSpan = 0;
        let notIDItemSpan = 0;
        switch (true) {
            case windowWidth >= 1550:
                IDItemSpan = 16;
                notIDItemSpan = 8;
                break;
            case windowWidth < 1550 && windowWidth > 1060:
                IDItemSpan = 24;
                notIDItemSpan = 12;
                break;
            default:
                IDItemSpan = 24;
                notIDItemSpan = 24;
                break;
        }
        return [
            {
                formItemApis: {
                    label: <span className="requiredStar">申请通道</span>,
                },
                item: [
                    {
                        formItemApis: {
                            name: 'applyType',
                            rules: [{ required: true, message: '请选择申请通道' }],
                        },
                        item: (
                            <Radio.Group disabled={!fillIn} onChange={applyTypeChange}>
                                {applyTypes.map(({ value, text }) => {
                                    return (
                                        <Radio key={value} value={value}>
                                            {text}
                                        </Radio>
                                    );
                                })}
                            </Radio.Group>
                        ),
                        setItemCol: false,
                    },
                    {
                        item: applyType ? (
                            <span className="applyTypeOk">通过信息验证！</span>
                        ) : null,
                        notFormItem: true,
                        setItemCol: false,
                    },
                ],
            },
            applyTypeTipItem(applyType),
            {
                formItemApis: {
                    label: '姓名',
                    name: 'name',
                    rules: [{ required: true }],
                },
                formItemSpan: notIDItemSpan,
                item: <Input style={{ width: '45%' }} disabled={!fillIn} />,
            },
            {
                formItemApis: {
                    label: <span className="requiredStar">身份证号</span>,
                },
                formItemSpan: IDItemSpan,
                item: [
                    {
                        formItemApis: {
                            name: 'idNo',
                            rules: [
                                {
                                    validator: idNoValidator,
                                },
                            ],
                        },
                        setItemCol: false,
                        item: <Input style={{ width: 'calc(50% - 75px)' }} disabled={!fillIn} />,
                    },
                    {
                        item: <span className="tipText">【号码含有英文字母请输入大写字母】</span>,
                        notFormItem: true,
                        setItemCol: false,
                    },
                ],
            },
            {
                formItemApis: {
                    label: <span className="requiredStar">身份证照片</span>,
                    name: 'idNoImg',
                    getValueFromEvent: e => {
                        if (Array.isArray(e)) {
                            return e;
                        }
                        return e && e.fileList;
                    },
                },
                item: (
                    <AliyunOSSUpload
                        onChange={changeIdNoImg}
                        disabled={!fillIn && !applyEdit}
                        name={'身份证证明照'}
                    />
                ),
            },
            {
                formItemApis: {
                    label: <span className="requiredStar">户口薄主页</span>,
                    name: 'hukoMain',
                    getValueFromEvent: e => {
                        if (Array.isArray(e)) {
                            return e;
                        }
                        return e && e.fileList;
                    },
                },
                item: (
                    <AliyunOSSUpload
                        onChange={changeHokoMain}
                        disabled={!fillIn && !applyEdit}
                        name={'户口薄主页'}
                    />
                ),
            },
            {
                formItemApis: {
                    label: <span className="requiredStar">户口薄本人页</span>,
                    name: 'hukoBenRen',
                    getValueFromEvent: e => {
                        if (Array.isArray(e)) {
                            return e;
                        }
                        return e && e.fileList;
                    },
                },
                item: (
                    <AliyunOSSUpload
                        onChange={changeHokoBenRen}
                        disabled={!fillIn && !applyEdit}
                        name={'户口薄本人页'}
                    />
                ),
            },
            {
                formItemApis: {
                    label: <span>优先申请材料</span>,
                    name: 'specialImg',
                    getValueFromEvent: e => {
                        if (Array.isArray(e)) {
                            return e;
                        }
                        return e && e.fileList;
                    },
                },
                item: (
                    <AliyunOSSUpload
                        onChange={changeSpecialImg}
                        disabled={!fillIn && !applyEdit}
                        name={'优先申请材料'}
                    />
                ),
            },
            {
                formItemApis: {
                    label: '身份类型',
                    name: 'identityType',
                },
                formItemSpan: notIDItemSpan,
                item: (
                    <Select disabled="true" defaultValue={'SELF'}>
                        {identityType.map(({ value, text }) => {
                            return (
                                <Option key={value} value={value}>
                                    {text}
                                </Option>
                            );
                        })}
                    </Select>
                ),
            },
            {
                formItemApis: {
                    label: <span className="requiredStar">性别</span>,
                },
                formItemSpan: notIDItemSpan,
                item: [
                    {
                        formItemApis: {
                            name: 'gender',
                        },
                        setItemCol: false,
                        item: <Input style={{ width: '45%' }} disabled />,
                    },
                    {
                        item: <span className="tipText">【根据身份证号获取】</span>,
                        notFormItem: true,
                        setItemCol: false,
                    },
                ],
            },
            {
                formItemApis: {
                    label: <span className="requiredStar">出生年月</span>,
                },
                formItemSpan: notIDItemSpan,
                item: [
                    {
                        formItemApis: {
                            name: 'birthday',
                        },
                        setItemCol: false,
                        item: <Input style={{ width: '45%' }} disabled />,
                    },
                    {
                        item: <span className="tipText">【根据身份证号获取】</span>,
                        notFormItem: true,
                        setItemCol: false,
                    },
                ],
            },
            {
                formItemApis: {
                    label: <span className="requiredStar">年龄</span>,
                },
                formItemSpan: notIDItemSpan,
                item: [
                    {
                        formItemApis: {
                            name: 'age',
                        },
                        setItemCol: false,
                        item: <Input style={{ width: '45%' }} disabled />,
                    },
                    {
                        item: <span className="tipText">【根据身份证号获取】</span>,
                        notFormItem: true,
                        setItemCol: false,
                    },
                ],
            },
            {
                formItemApis: {
                    label: '社保卡号',
                    name: 'cardNo',
                },
                formItemSpan: notIDItemSpan,
                item: <Input disabled />,
            },
            {
                formItemApis: {
                    label: '民族',
                    name: 'nation',
                    rules: [{ required: true }],
                },
                formItemSpan: notIDItemSpan,
                item: <Input disabled={!fillIn} />,
            },
            {
                formItemApis: {
                    label: '文化程度',
                    name: 'education',
                    rules: [{ required: true }],
                },
                formItemSpan: notIDItemSpan,
                item: (
                    <Select disabled={!fillIn}>
                        {educations.map(({ value, text }) => {
                            return (
                                <Option key={value} value={value}>
                                    {text}
                                </Option>
                            );
                        })}
                    </Select>
                ),
            },
            {
                formItemApis: {
                    label: '籍贯',
                    name: 'hometown',
                    rules: [{ required: true }],
                },
                formItemSpan: notIDItemSpan,
                item: <Input />,
            },
            {
                formItemApis: {
                    label: '婚姻状况',
                    name: 'maritalStatus',
                    rules: [{ required: true }],
                },
                formItemSpan: notIDItemSpan,
                item: (
                    <Select disabled={!fillIn}>
                        {maritalStatuTypes.map(({ value, text }) => {
                            return (
                                <Option key={value} value={value}>
                                    {text}
                                </Option>
                            );
                        })}
                    </Select>
                ),
            },
            {
                formItemApis: {
                    label: '固定电话',
                    name: 'telephone',
                },
                formItemSpan: notIDItemSpan,
                item: <Input disabled={!fillIn} />,
            },
            {
                formItemApis: {
                    label: '户籍所在地',
                    name: 'areas',
                    rules: [{ required: true }],
                },
                formItemSpan: notIDItemSpan,
                item: <Cascader options={cityOptions} disabled={!fillIn} placeholder="地区选择" />,
            },
            {
                formItemApis: {
                    label: '户籍地详址',
                    name: 'hometownAddress',
                    rules: [{ required: true }],
                },
                formItemSpan: notIDItemSpan,
                item: <Input disabled={!fillIn} />,
            },
            {
                formItemApis: {
                    label: '现居地详址',
                    name: 'livingAddress',
                    rules: [{ required: true }],
                },
                formItemSpan: notIDItemSpan,
                item: <Input disabled={!fillIn} />,
            },
            {
                formItemApis: {
                    label: '移动电话',
                    name: 'cellPhone',
                    rules: [{ required: true }],
                },
                formItemSpan: notIDItemSpan,
                item: <Input disabled={!fillIn} maxLength={11} />,
            },
            {
                formItemApis: {
                    label: <span className="requiredStar">护理区</span>,
                },
                formItemSpan: IDItemSpan,
                item: [
                    {
                        formItemApis: {
                            name: 'nursingArea',
                            rules: [{ required: true }],
                        },
                        setItemCol: false,
                        item: (
                            <Select
                                disabled={!fillIn && !applyEdit}
                                style={{ width: 'calc(50% - 75px)' }}>
                                {nursingAreas
                                    .filter(nursing => nursing.age <= age)
                                    .map(({ value, text }) => {
                                        return (
                                            <Option key={value} value={value}>
                                                {text}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        ),
                    },
                    {
                        item: age ? (
                            <span className="tipText">
                                【建议选择
                                <span style={{ color: '#f00' }}>{defaultNursingAreas().text}</span>
                                】
                                <Tooltip
                                    title={
                                        <div>
                                            <div>
                                                根据申请人{age}岁，评估表总分{assessmentTotal}分
                                            </div>
                                            <div>建议选择{defaultNursingAreas().text}</div>
                                        </div>
                                    }>
                                    <QuestionCircleOutlined />
                                </Tooltip>
                            </span>
                        ) : null,
                        notFormItem: true,
                        setItemCol: false,
                    },
                ],
            },
            {
                item: <Divider>监护人信息</Divider>,
            },
            {
                formItemApis: {
                    label: '监护人姓名',
                    name: 'guardian',
                    rules: [{ required: true }],
                },
                formItemSpan: notIDItemSpan,
                item: <Input disabled={!fillIn} />,
            },
            {
                formItemApis: {
                    label: '与申请人关系',
                    name: 'relate',
                    rules: [{ required: true }],
                },
                formItemSpan: notIDItemSpan,
                item: <Input disabled={!fillIn} />,
            },
            {
                formItemApis: {
                    label: '移动电话',
                    name: 'guardianCellPhone',
                    rules: [{ required: true }],
                },
                formItemSpan: notIDItemSpan,
                item: <Input disabled={!fillIn} maxLength={11} />,
            },
            {
                formItemApis: {
                    label: '联系地址',
                    name: 'guardianAreas',
                    rules: [{ required: true }],
                },
                formItemSpan: notIDItemSpan,
                item: <Cascader options={cityOptions} disabled={!fillIn} />,
            },
            {
                formItemApis: {
                    label: '联系详址',
                    name: 'guardianLivingAddress',
                    rules: [{ required: true }],
                },
                formItemSpan: notIDItemSpan,
                item: <Input disabled={!fillIn} />,
            },
            {
                formItemApis: {
                    label: '固定电话',
                    name: 'guardianTelephone',
                },
                formItemSpan: notIDItemSpan,
                item: <Input disabled={!fillIn} />,
            },
            fillIn || applyEdit
                ? {
                      item: (
                          <div style={{ textAlign: 'center' }}>
                              <Button type="primary" htmlType="submit" loading={submitLoading}>
                                  提交申请
                              </Button>
                          </div>
                      ),
                  }
                : null,
        ];
    };

    return (
        <div className="baseInfoBox">
            <div className="title">
                {applyId
                    ? '申请登记信息'
                    : `福州市社会福利院公办养老机构评估轮候申请${applyEdit ? '变更' : ''}`}
            </div>
            {applyEdit ? <div className="subTitle"></div> : null}
            <Spin spinning={infoLoading}>
                <XForm
                    formApis={{
                        name: 'baseInfo',
                        onFinish: onFinish,
                    }}
                    formItems={formItems()}
                    ref={xFormRef}
                />
            </Spin>
        </div>
    );
};
export default ApplyInfo;
